export const changeStyleColor = (color) => (event) => {
	event.target.style.color = color
}
